import React from 'react';
import { FileTextIcon, PlayCircleIcon } from 'lucide-react';
export function HighlightsAndResourcesSection() {
  return <div className="grid md:grid-cols-2 gap-12 mb-20" data-id="element-979">
      {/* Highlights */}
      <div className="bg-gray-50 rounded-2xl p-8 border border-gray-200" data-id="element-980">
        <h2 className="text-2xl font-bold text-[#002d4d] mb-6 flex items-center" data-id="element-981">
          <span className="w-8 h-1 bg-[#f5693d] mr-4 rounded-full" data-id="element-982"></span>
          Highlights
        </h2>
        <ul className="space-y-4" data-id="element-983">
          <li className="flex items-start" data-id="element-984">
            <span className="text-[#f5693d] mr-3 mt-1 text-xl leading-none" data-id="element-985">
              •
            </span>
            <span className="text-gray-700 text-lg" data-id="element-986">
              Fiber Laser Sheet &amp; Tube Cutting
            </span>
          </li>
          <li className="flex items-start" data-id="element-987">
            <span className="text-[#f5693d] mr-3 mt-1 text-xl leading-none" data-id="element-988">
              •
            </span>
            <span className="text-gray-700 text-lg" data-id="element-989">
              1kW—40kW—Highest Power Fiber Laser—Cut up to 8" thick
            </span>
          </li>
          <li className="flex items-start" data-id="element-990">
            <span className="text-[#f5693d] mr-3 mt-1 text-xl leading-none" data-id="element-991">
              •
            </span>
            <span className="text-gray-700 text-lg" data-id="element-992">European quality</span>
          </li>
          <li className="flex items-start" data-id="element-993">
            <span className="text-[#f5693d] mr-3 mt-1 text-xl leading-none" data-id="element-994">
              •
            </span>
            <span className="text-gray-700 text-lg" data-id="element-995">
              Integrated Automation Solutions
            </span>
          </li>
          <li className="flex items-start" data-id="element-996">
            <span className="text-[#f5693d] mr-3 mt-1 text-xl leading-none" data-id="element-997">
              •
            </span>
            <span className="text-gray-700 text-lg" data-id="element-998">
              <strong className="text-[#f5693d]" data-id="element-999">BEST Pricing</strong> in the
              Industry
            </span>
          </li>
          <li className="flex items-start pt-2" data-id="element-1000">
            <a href="https://www.peakedm.com/uploaded/files/Bodor%20Files/Why%20we%20need%20a%2010kw+%20fiber%20laser-2021.03.pdf?direct=1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-[#002d4d] hover:text-[#f5693d] font-bold underline transition-colors" data-id="element-1001">
              <FileTextIcon className="w-5 h-5 mr-2" data-id="element-1002" />
              High-Power Laser Benefits Here
            </a>
          </li>
        </ul>
      </div>

      {/* Resources & Videos */}
      <div className="space-y-6" data-id="element-1003">
        <a href="https://www.peakedm.com/uploaded/files/Bodor%20Files/Bodor%20Product%20Intro.pdf?direct=1" target="_blank" rel="noopener noreferrer" className="flex items-center p-6 bg-[#002d4d] text-white rounded-xl hover:bg-[#003d66] transition-colors shadow-md group" data-id="element-1004">
          <div className="bg-white/20 p-3 rounded-lg mr-4 group-hover:bg-[#f5693d] transition-colors" data-id="element-1005">
            <FileTextIcon className="w-8 h-8" data-id="element-1006" />
          </div>
          <div data-id="element-1007">
            <h3 className="font-bold text-lg" data-id="element-1008">Full Bodor Product Brochure</h3>
            <p className="text-white/80 text-sm" data-id="element-1009">Click to Download</p>
          </div>
        </a>

        <div className="bg-white rounded-xl border border-gray-200 p-6 shadow-sm" data-id="element-1010">
          <h3 className="font-bold text-[#002d4d] text-lg mb-4" data-id="element-1011">
            Featured Videos
          </h3>
          <div className="space-y-4" data-id="element-1012">
            <a href="https://www.linkedin.com/posts/jinan-bodor-cnc-machine-co-ltd_bodor-laser-cutting-activity-6783645141715550208-Uhyd" target="_blank" rel="noopener noreferrer" className="flex items-start hover:bg-gray-50 p-3 rounded-lg transition-colors group" data-id="element-1013">
              <PlayCircleIcon className="w-6 h-6 text-[#f5693d] mr-3 flex-shrink-0 mt-0.5" data-id="element-1014" />
              <span className="text-gray-700 group-hover:text-[#002d4d] transition-colors" data-id="element-1015">
                Bodor 12kw laser cutting 30mm(1.18") carbon steel
              </span>
            </a>
            <a href="https://youtu.be/E8NbjV9GxEw" target="_blank" rel="noopener noreferrer" className="flex items-start hover:bg-gray-50 p-3 rounded-lg transition-colors group" data-id="element-1016">
              <PlayCircleIcon className="w-6 h-6 text-[#f5693d] mr-3 flex-shrink-0 mt-0.5" data-id="element-1017" />
              <span className="text-gray-700 group-hover:text-[#002d4d] transition-colors" data-id="element-1018">
                Bodor 40kW Laser Cutting Machine
              </span>
            </a>
            <a href="https://youtu.be/ZLPCopB0br0" target="_blank" rel="noopener noreferrer" className="flex items-start hover:bg-gray-50 p-3 rounded-lg transition-colors group" data-id="element-1019">
              <PlayCircleIcon className="w-6 h-6 text-[#f5693d] mr-3 flex-shrink-0 mt-0.5" data-id="element-1020" />
              <span className="text-gray-700 group-hover:text-[#002d4d] transition-colors" data-id="element-1021">
                BodorGenius Ultra-High Power Laser Head
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>;
}